<!-- 科研成果 成就页面 点击发布调转至该页面 -->
<template>
  <div class="AddAchievements">
    <div class="describe">
      <el-form :model="describe" :rules="describeRules" ref="describeForm" class="demo-ruleForm">
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">姓名</div>
        </div>
        <el-form-item prop="alumniName">
          <el-input v-model="describe.alumniName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">联系方式</div>
        </div>
        <el-form-item prop="phone">
          <el-input v-model="describe.phone" maxlength="11" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">科技成果</div>
        </div>
        <el-form-item prop="name">
          <el-input v-model="describe.name" placeholder="请输入科技成果"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">成果概述</div>
        </div>
        <el-form-item prop="description">
          <el-input type="textarea" placeholder="请填写成果概述" v-model="describe.description" maxlength="200" show-word-limit
            :autosize="{ minRows: 6, maxRows: 6 }">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">成果概述文件</div>
      </div>
      <div class="describeUpload">
        <van-uploader :before-read="beforeDescribeUpload" :after-read="afterDescribeUpload"
          :before-delete="deleteDescribeUpload" :max-size="51200" accept="application/pdf" :max-count="1"
          v-model="describeUploadUrl">
          <div class="uploadCard">
            <div class="uploadImgDiv">
              <img src="../../assets/image/btn_shangchuan_nor.png" alt="上传" class="uploadImg" />
            </div>
            <div class="tips">
              上传PDF文件
              <br />
              限50M
            </div>
          </div>
        </van-uploader>
      </div>
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">取得成绩</div>
      </div>
      <div class="photoUpload">
        <van-uploader :max-count="5" :before-read="beforePhotoUpload" :after-read="afterPhotoUpload"
          :before-delete="deletePhotoUpload" v-model="photoUploadUrl" multiple>
          <div class="uploadCard">
            <div class="uploadImgDiv">
              <img src="../../assets/image/btn_shangchuan_nor.png" alt="上传" class="uploadImg" />
            </div>
            <div class="tips">
              上传照片
              <br />
              （最多可上传5张）
            </div>
          </div>
        </van-uploader>
      </div>
      <div class="title clearfix">
        <div class="icon"></div>
        <div class="titleName">取得成绩文件</div>
      </div>
      <div class="fileUpload">
        <van-uploader :before-read="beforeFileUpload" :after-read="afterFileUpload" :before-delete="deleteFileUpload"
          :max-size="51200" accept="application/pdf" :max-count="1" v-model="fileUploadUrl">
          <div class="uploadCard">
            <div class="uploadImgDiv">
              <img src="../../assets/image/btn_shangchuan_nor.png" alt="上传" class="uploadImg" />
            </div>
            <div class="tips">
              上传PDF文件
              <br />
              限50M
            </div>
          </div>
        </van-uploader>
      </div>
      <div class="submit">
        <button class="submitBtn" @click="submit">提 交</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      describe: {
        name: "",
        description: "",
        alumniName: "",
        phone: "",
        userId: window.localStorage.getItem("user_id"),
        source: 2
      },
      describeUploadUrl: [],
      photoUploadUrl: [],
      fileUploadUrl: [],
      desc_doc: [],
      achievement_doc: [],
      achievement_img: [],
      describeRules: {
        alumniName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 15 个字符",
            trigger: "blur",
          },
        ],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        name: [
          { required: true, message: "请输入科技成果", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        description: [
          { required: true, message: "请填写成果概述", trigger: "blur" },
        ],
      },
    };
  },
  created() { },
  methods: {
    beforeDescribeUpload(file) {
      if (file.type !== "application/pdf") {
        this.$toast("请上传pdf文件");
        return false;
      }
      return true;
    },
    async afterDescribeUpload(file) {
      this.describeUploadUrl.splice(1, 1);
      let param = new window.FormData();
      param.append("file", file.file);
      console.log(file)
      const result = await this.$http.post("/fileUpload/uploadFile", param);
      if (result.data.result == "上传成功") {
        this.desc_doc = result.data.absolutePath;
      } else {
        this.$toast(result.data.msg);
      }
    },
    deleteDescribeUpload() {
      this.describeUploadUrl = [];
      this.desc_doc = [];
    },
    beforePhotoUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$toast("请上传jpg,png 格式图片");
        return false;
      }
      return true;
    },
    async afterPhotoUpload(file) {
      for (let i = 0; i < this.photoUploadUrl.length; i++) {
        if (this.photoUploadUrl[i].file == undefined) {
          this.photoUploadUrl.splice(i, 1);
          console.log(this.photoUploadUrl)
        }
      }
      let param = new window.FormData();
      param.append("images", file.file);
      const result = await this.$http.post("/fileUpload/uploadImages", param);
      if (result.data[0].result == "上传成功") {
        this.achievement_img.push(result.data[0].absolutePath);
        console.log(this.achievement_img);
      } else {
        this.$toast(result.data.msg);
      }
    },
    deletePhotoUpload(detail) {
      this.achievement_img.splice(detail.index, 1);
      this.photoUploadUrl.splice(detail.index, 1);
      console.log(this.achievement_img);
    },
    beforeFileUpload(file) {
      if (file.type !== "application/pdf") {
        this.$toast("请上传pdf文件");
        return false;
      }
      return true;
    },
    async afterFileUpload(file) {
      this.fileUploadUrl.splice(1, 1);
      let param = new window.FormData();
      param.append("file", file.file);
      const result = await this.$http.post("/fileUpload/uploadFile", param);
      if (result.data.result == "上传成功") {
        this.achievement_doc = result.data.absolutePath;
      } else {
        this.$toast(result.data.msg);
      }
    },
    deleteFileUpload() {
      this.fileUploadUrl = [];
      this.achievement_doc = [];
    },
    submit() {
      this.$refs.describeForm.validate(async (valid) => {
        // 请求api之前，前端先进行的一个校验
        if (!valid) {
          return;
        }
        const result = await this.$http({
          url: "/achievementTransform/sendAchievement?" + 'imgUrl=' + this.achievement_img.toString() + '&DescDoc=' + this.desc_doc + '&achievementDoc=' + this.achievement_doc + '&userId=' + parseInt(window.localStorage.getItem("user_id")) + '&name=' + this.describe.title + '&phone=' + this.describe.phone + '&description=' + this.describe.description + '&alumniName=' + this.describe.name,
          method: "POST",
          headers: { "Content-Type": 'application/json' },
        })
        if (result.data.AchievementByName == true) {
          this.$toast("提交成功");
          window.history.back(-1);
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.AddAchievements {
  position: relative;

  .userData {
    position: relative;
    left: 5%;
    width: 90%;
  }

  .describe {
    position: relative;
    left: 5%;
    width: 90%;
  }

  .describeUpload,
  .photoUpload,
  .fileUpload {
    margin: 15px 0 20px 0;

    .uploadCard {
      position: relative;
      width: 45vw;
      height: 40vw;
      background: #ffffff;
      border: 1px solid #c2c2c2;
      border-radius: 10px;

      .uploadImgDiv {
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translateX(-50%);
        width: 25%;

        .uploadImg {
          width: 100%;
        }
      }

      .tips {
        position: absolute;
        left: 50%;
        top: 60%;
        transform: translateX(-50%);
        text-align: center;
        font-weight: 400;
        color: #666666;
        white-space: nowrap;
      }
    }
  }

  .submit {
    margin: 30px 0 20px 0;
    width: 100%;

    .submitBtn {
      border: 0;
      border-radius: 30px;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}

.el-form-item {
  margin-top: 15px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.title {
  margin-top: 10px;

  .icon {
    float: left;
    height: 5vw;
    width: 3px;
    background: #00706E;
    border-radius: 3px;
  }

  .titleName {
    float: left;
    margin-left: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #333333;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/achievements/AddAchievements.vue